import { defineStore } from "pinia";
import { ref } from "vue";
import Cookies from "js-cookie";
import { API_BASE_URL, GETGOOGLEFONTS } from "../utils/appConst";

const getGoogleFonts = `${API_BASE_URL}${GETGOOGLEFONTS}`;
const CACHE_KEY = "google_fonts_cache";
const LAST_REQUEST_KEY = "last_font_request";
const COOLDOWN_MS = 60 * 60 * 1000 * 24 * 7;

export const useFontStore = defineStore("fonts", () => {
  const fonts = ref<any[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  async function fetchGoogleFonts(token: string) {
    isLoading.value = true;
    try {
      const cachedFonts = Cookies.get(CACHE_KEY);
      if (cachedFonts) {
        fonts.value = JSON.parse(cachedFonts);
        isLoading.value = false;
        return;
      }

      // Cooldown check - commented out
      // const lastRequest = Cookies.get(LAST_REQUEST_KEY);
      // if (lastRequest) {
      //   const lastRequestTime = parseInt(lastRequest, 10);
      //   if (Date.now() - lastRequestTime < COOLDOWN_MS) {
      //     fonts.value = [];
      //     isLoading.value = false;
      //     return;
      //   }
      // }

      const response = await fetch(getGoogleFonts, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      });
      if (!response.ok) throw new Error("Failed to fetch fonts");
      const data = await response.json();

      if (data.data && data.data.length > 0) {
        fonts.value = data.data;
        if (Cookies.get("permittedCookies") === "true") {
          const oneWeekFromNow = new Date();
          oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);
          Cookies.set(CACHE_KEY, JSON.stringify(data.data), {
            expires: oneWeekFromNow,
          });
        }
      } else {
        fonts.value = [];
        if (Cookies.get("permittedCookies") === "true") {
          Cookies.set(LAST_REQUEST_KEY, Date.now().toString());
        }
      }
    } catch (err: any) {
      error.value = err.message;
      if (Cookies.get("permittedCookies") === "true") {
        Cookies.set(LAST_REQUEST_KEY, Date.now().toString());
      }
    } finally {
      isLoading.value = false;
    }
  }

  return { fonts, isLoading, error, fetchGoogleFonts };
});